<template>
  <div id="profile-personal-id-section" class="section container">
    <div class="section-header">
      <div class="section-title">
        <div class="section-icon section-icon-email"  :class="brandClass()"></div>
        <div class="section-title-label">
          {{$t("profile_account_data_personalID_summary_title")}}
        </div>
      </div>
      <div @keydown="ariaClick" role="button" tabindex="0" @click="editClicked()" class="section-edit pointer" :class="{'hidden': editDisabled}" v-if="!editMode">
        <div class="section-edit-icon"></div>
        <div class="section-edit-label">
          {{$t("profile_edit_button")}}
        </div>
      </div>
    </div>
    <form id="profile-personal-id-form" v-if="editMode" novalidate class="form" @submit.prevent="submitChanges">
      <div class="custom-field">
        <OneInput
          :brandClass="brandClass()"
          :profileStyle="true"
          v-model.trim="form.email" 
          :form="v$.form"     
          :label="$t('profile_email_label')+'*'" 
          :paramName="'email'"
          :id="'email'"
          @blur="touchForm('email')"
          :errors="[
            {message:$t('profile_email_error_required'), thereIsTheError:v$.form.email.required.$invalid},
            {message:$t('profile_email_error_valid'), thereIsTheError:v$.form.email.email.$invalid},
            {message:$t('register_page_password_error_not_allowed'), thereIsTheError:v$.form.email.customEmailRegexpValidation.$invalid},
          ]"
        />
      </div>
      <div class="mandatory" style="order:100">*{{$t("generic_mandatory_fields")}}</div>
      <div class="custom-field" style="margin-top: 15px; display: flex">
<!--        <OneCheckbox-->
<!--          :brandClass="brandClass()"-->
<!--          :id="`preferred-id`"-->
<!--          v-model="form.preferred"-->
<!--          :required="false"-->
<!--          :paramName="`preferred`"-->
<!--        ></OneCheckbox>-->
<!--        <div class="checkbox-label" for="preferred" :class="brandClass()"-->
<!--          >{{$t("profile_account_data_summary_ID_edit_preferred_email")}}</div-->
<!--        >-->

      </div>
      <div class="buttonsContainer flex_button_container">
        <OneButton
          :brandClass="brandClass()"
          :profileStyle="true"
          :type="'primary'"
          :label="$t('profile_save_button')"
          :disabled="isButtonDisabled"
          @click="showAuthenticationPopup()"
        />
        <OneButton
          :brandClass="brandClass()"
          :profileStyle="true"
          :type="'secondary'"
          :label="$t('profile_cancel_button')"
          @click="cancelClicked()"
        />
      </div>
    </form>
    <div v-if="!editMode">
      <div class="infos BMWID-information">
        <div class="info">
          <div class="value email-value">{{form.email}}</div>
        </div>
      </div>
    </div>
    <hr>
  </div>
  <AuthMethodsPopup 
    :isAuthenticationPopupVisible="isAuthenticationPopupVisible"
    :isPasskeyOptionVisible="isPasskeyPopupAvailable"
    :isTwoFactorAuthOptionVisible="is2FAPopupAvailable"
    :areButtonsDisabled="areButtonsDisabled"
    @passkeyOptionSelected="onPasskeyOptionSelected"
    @twoFactorAuthOptionSelected="onTwoFactorAuthOptionSelected"
    @passwordOptionSelected="onPasswordOptionSelected"
    @closeAuthMethodsPopup="onCloseAuthMethodsPopup"
  />
  <PasswordPopup 
    :isPasswordPopupVisible="isPasswordPopupVisible" 
    :isBackButtonReplacingCancel="isAuthenticationPopupAvailable"
    :passwordError="passwordError"
    :resetPasswordFormProp="resetPasswordForm"
    @resetPasswordError="resetPasswordError"
    @closePasswordPopup="closePasswordPopupFromUserClick"
    @userPassword="activatePassword"
  />
</template>
<style lang="scss" scoped>
  .radio {
    position: static !important;
  }

  .radio_label{
    font-size: 16px;
    margin-left: 15px;
    line-height: 24px;

    @media (max-width: 768px) {
      font-size: 14px;
    }

    &.__m{
      line-height: 27px;
      font-size: 18px;
      font-weight: 400;
      font-family: MINISansSerif;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }
    &.__t{
      line-height: inherit;
      font-size: 18px;
      font-family: ToyotaSemibold;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }
    &.__alphabet{
      font-size: 16px;
      font-weight: 500;
      font-family: AlphabetSansPro-Medium;
      color: $alphabetblue;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }
</style>
<script>
import useVuelidate from '@vuelidate/core'
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import { defineAsyncComponent } from 'vue'

import {
  required,
  email
} from "@vuelidate/validators";

import AuthMethodsPopup from "@/components/ProfileForm/components/AuthMethodsPopup.vue";
import PasswordPopup from "@/components/ProfileForm/components/PasswordPopup.vue";

export default {
  inject:['$c', '$t', 'brandClass'],
  setup() {
    return { v$: useVuelidate() }
  },
  name: "ProfilePersonalId",
  components:{
    OneCheckbox: defineAsyncComponent(() =>
      import('../../../../gcdm-one-library/gcdm-one-checkbox/src/OneCheckbox')
    ),
    AuthMethodsPopup,
    PasswordPopup
  },
  //validations from vuelidate
  mixins: [
    oneUtils.accessibilityMixin, 
    oneUtils.customValidationMixin
  ],
  props: {
    user: {},
    editDisabled: {
      default: false,
      type: Boolean,
    },
    passkeyEntries: {
      default: [],
      type: Array
    }
  },
  data: () => ({
    form: {
      email: null
    },
    password: "",
    editMode: false,
    isAuthenticationPopupVisible: false,
    isPasskeyPopupVisible: false,
    is2FAPopupVisible: false,
    isPasswordPopupVisible: false,
    passwordError: false,
    resetPasswordForm: false,
    areButtonsDisabled: false
  }),
  //vuelidate custom validations
  validations: {
    form: {
      email: {
        customEmailRegexpValidation: function (value) {
          return this.customEmailRegexpValidation(value);
        },
        required,
        email,
      }
    },
  },
  computed: {
    isButtonDisabled: function () {
      return (
        !!this.v$.$errors.length
      );
    },
    /**
     * Return the auth methods allowed according to the config for personal id change
     */
     getAuthMethodsForPersonalIdChange() {
      return this.$c("_auth_methods_for_personal_id_change");
    },
    /**
     * Return true if passkey auth method for personal id change is allowed according to the config, false otherwise and undefined if nothing is specified
     */
     isPasskeyPopupAvailable() {
      const isEnabledOnConfig = this.getAuthMethodsForPersonalIdChange?.includes(oneUtils.enums.authMethodsForPersonalIdChange.PASSKEY);
      const isSetByUser = this.hasUserPasskeySet;

      return isEnabledOnConfig && isSetByUser;
    },
    /**
     * Return true if 2FA auth method for personal id change is allowed according to the config, false otherwise and undefined if nothing is specified
     */
    is2FAPopupAvailable() {
      const isEnabledOnConfig = this.getAuthMethodsForPersonalIdChange?.includes(oneUtils.enums.authMethodsForPersonalIdChange.TWO_FACTOR_AUTH);
      const isSetByUser = this.hasUser2FASet;

      return isEnabledOnConfig && isSetByUser;
    },
    /**
     * Return true if passkey OR 2FA auth popups are available
     * 
     * @uses this.isPasskeyPopupAvailable and this.is2FAPopupAvailable
     */
    isAuthenticationPopupAvailable() {
      return (
        this.isPasskeyPopupAvailable || 
        this.is2FAPopupAvailable
      );
    },
    /**
     * Return true if user has passkey set / enabled, false otherwise
     */
     hasUserPasskeySet() {
      return !!this.passkeyEntries?.length;
    },
    /**
     * Return true if user has 2FA set / enabled, false otherwise
     */
    hasUser2FASet() {
      return true; // TODO: check if user has 2FA enabled
    },
  },
  mounted() {
    this.prefillForm();
    this.getComponentAction();
  },
  methods: {
    /**
     * Checks the current component status in store
     */
    getComponentAction() {
      if(oneUtils.utils.getComponentAction()?.action == 'account_data-profile_personal_id-is_edit_mode') {
        this.editClicked();
        oneUtils.utils.clearComponentAction();

        // Promise.resolve() will wait for the next macrotask to be called to execute the provided function (almost like a setTimeout())
        Promise.resolve().then(() => {
          oneUtils.utils.scrollTo("profile-personal-id-section");
        });
      }
    },
    /**
     * Tracy tracking: change BMW ID intention
     * edit management
     */
    editClicked(){
      this.handleEditMode();
    },
    /**
     * Tracy tracking: change BMW ID cancelled
     * edit management
     */
    cancelClicked(){
      this.handleEditMode();
    },
    /**
     * Initialize form data
     */
    prefillForm: function () {
      // get user email
      this.form.email = this.user.email;
      this.touchForm("email");
    },
    /**
     * touch function on field
     */
    touchForm(fieldName) {
      this.v$.form[fieldName].$touch();
    },
    /**
     * form submit
     * edit management
     */
    submitChanges() {
      const newMail = this.form.email;
      this.submitUpdateForEmail(newMail);
    },
    /**
     * Change ID api and errors management
     */
    submitUpdateForEmail(newMail, newType) {
      oneUtils.utils.showGlobalLoader();
      oneUtils.httpClient
        .changeId(newMail, this.password, window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
        .then(() => {
          oneUtils.utils.showMessage("SUCCESS", this.$t("profile_personalid_success"));
          oneUtils.utils.hideGlobalLoader();
          this.handleEditMode();
          this.setPasswordPopupVisibility(false);
        })
        .catch((err) => {
          oneUtils.utils.hideGlobalLoader();
          if(err?.errorCode==oneUtils.enums.errorReasons.EMAIL_NOT_UNIQUE){
            oneUtils.utils.showMessage("ERROR", this.$t("profile_email_error_already_used"));
          }else if(err?.errorCode==oneUtils.enums.errorReasons.EMAIL_NOT_COMPLIANT){
            oneUtils.utils.showMessage("ERROR", this.$t("profile_email_error_valid"));
          }else if(err?.errorCode==oneUtils.enums.errorReasons.WRONG_PASSWORD){
            this.passwordError = this.$t("generic_error_profile_wrong_password");
          }else{
            oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
          }
        });
    },
    /**
     * Change edit mote status and call prefillForm function
     */
    handleEditMode(){
      if(!this.editMode) {
        this.editMode = true;
      }
      else {
        this.editMode = false;
        this.prefillForm();
      }
    },
    /**
     * Show the auth popup if requirements are met: email must have been changed and ID popup must be enabled from config
     */
    showAuthenticationPopup() {
      const newMail = this.form.email;

      // Check if email has changed
      const isEmailChanged = newMail !== this.user.email;

      // If email has NOT changed...
      if(!isEmailChanged) {
        // ... return to view mode (do nothing)
        this.handleEditMode();
        return;
      }

      // If other auth method popups are NOT available...
      if(!this.isAuthenticationPopupAvailable) {
        // ... show password auth method popup (because it's ALWAYS available)
        this.setPasswordPopupVisibility(true);
      }
      // Else...
      else {
        // ... show the authentication methods popup, so the user can pick the auth method they wish to use
        this.setAuthenticationPopupVisibility(true);
      }
      
    },
    /**
     * Set the authentication methods popups' visibility to false
     */
    resetAuthenticationMethodsPopups() {
      this.setPasskeyPopupVisibility(false);
      this.set2FAPopupVisibility(false);
      this.setPasswordPopupVisibility(false);
    },
    /**
     * Set the auth methods popup visibility
     */
    setAuthenticationPopupVisibility(isVisible = false) {
      this.isAuthenticationPopupVisible = isVisible;
    },
    /**
     * Set the passkey auth method popup visibility
     */
    setPasskeyPopupVisibility(isVisible = false) {
      this.isPasskeyPopupVisible = isVisible;
    },
    /**
     * Set the 2FA auth method popup visibility
     */
    set2FAPopupVisibility(isVisible = false) {
      this.is2FAPopupVisible = isVisible;
    },
    /**
     * Set the password auth method popup visibility
     */
    setPasswordPopupVisibility(isVisible = false) {
      this.isPasswordPopupVisible = isVisible;
    },
    /**
     * Event handler for passkey option selected: opens passkey auth popup
     */
    onPasskeyOptionSelected() {
      this.getPasskeyBodyData();
    },
    /**
     * Get the passkey body data (step 1 of 4): get the body we need to fill with the user's email and to send to the "passkey journey step 2 API"
     */
    getPasskeyBodyData() {
      this.areButtonsDisabled = true;

      // Get body data, where we need to fill a specific field with the user's email:
      // we will send this body to another passkey API, in order to retreive the user's available passkeys
      oneUtils.httpClient.passkeyLoginStart().then((res) => {
        const body = res.data;
        body.callbacks[0].input[0].value = this.user.email;

        // Call the passkey journey step 2
        this.getAvailablePasskeys(body);
      }).catch(() => {
        // Close auth methods popup, the user needs to see the error message without the popup overlay
        this.areButtonsDisabled = false;
        this.setAuthenticationPopupVisibility(false);
        oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
      });
    },
    /**
     * Get the list of the user's available passkey (step 2 of 4)
     * 
     * @param body - the body received from the "passkey journey step 1 API call", filled with the user's email
     */
    getAvailablePasskeys(body) {
      oneUtils.httpClient.passkeyLoginStart(body).then((res) => {
        this.showNavigatorPasskeyData(res);
      }).catch(() => {
        // Close auth methods popup, the user needs to see the error message without the popup overlay
        this.areButtonsDisabled = false;
        this.setAuthenticationPopupVisibility(false);
        oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
      });
    },
    /**
     * Build the passkey devices data and let the user pick the device they want to use to authenticate (step 3 of 4)
     */
    showNavigatorPasskeyData(res) {
      const callback = res.data.callbacks?.find(el => el.type=="MetadataCallback");
      const output = callback?.output?.find(el => el.name="data");
      const data = output?.value;         
      const publicKeyCredentialRequestOptions = {
        challenge: Uint8Array.from(atob(data.challenge), c => c.charCodeAt(0)),
        allowCredentials: [],
        timeout: data.timeout,
      };

      data._allowCredentials.forEach((credential) => {
        publicKeyCredentialRequestOptions.allowCredentials.push({
          id: new Int8Array(credential.id).buffer,
          type: credential.type
        });
      });

      navigator.credentials.get({publicKey: publicKeyCredentialRequestOptions}).then((credentialInfo) => {
        const body = res.data;
        const rawId = credentialInfo.id;
        const clientData = String.fromCharCode.apply(null, new Uint8Array(credentialInfo.response.clientDataJSON));
        const authenticatorData = new Int8Array(credentialInfo.response.authenticatorData).toString();       
        const signature = new Int8Array(credentialInfo.response.signature).toString()

        body.callbacks[1].input[0].value = clientData + "::" + authenticatorData + "::" + signature + "::" + rawId;

        this.passkeyJourneyFinalCall(body);
      }).catch(() => {
        // Navigator error
        // Close auth methods popup, the user needs to see the error message without the popup overlay
        this.areButtonsDisabled = false;
        this.setAuthenticationPopupVisibility(false);
        oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
      });
    },
    /**
     * Final passkey journey call (step 4 of 4): retrieve the authorization parameter.
     * Implementation from GCDM-255332.
     * 
     * @param body - the body retrieved from the previous API calls, filled with data
     */
    passkeyJourneyFinalCall(body) {
      oneUtils.httpClient.passkeyLoginComplete(body).then((resLoginComplete) => {
        const authorization = resLoginComplete?.data?.redirect_to.split("&").splice(-1)[0].replace("authorization=", "");

        console.log("Passkey authorization: ", authorization);

        // TODO: once team AirOne has their implementation ready, we will perform the provided API call sending the authorization parameter retreived
      }).catch((err) => {
        oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
      });

      this.areButtonsDisabled = false;
      this.setAuthenticationPopupVisibility(false);
    },
    /**
     * Event handler for 2FA option selected: opens 2FA popup
     */
    onTwoFactorAuthOptionSelected() {
      this.setAuthenticationPopupVisibility(false);

      // TODO: this.set2FAPopupVisibility(true);

      this.onPasswordOptionSelected();
    },
    /**
     * Event handler for password option selected: opens password auth popup
     */
    onPasswordOptionSelected() {
      this.setAuthenticationPopupVisibility(false);

      this.setPasswordPopupVisibility(true);
    },
    /**
     * Event handler for closing the auth method popup: sets visibility to false
     */
    onCloseAuthMethodsPopup() {
      this.setAuthenticationPopupVisibility(false);
    },

    // PASSWORD POPUP METHODS

    resetPasswordError(value) {
      this.passwordError = value;
    },
    closePasswordPopupFromUserClick(isPasswordPopupClosedByBackButton) {
      this.setPasswordPopupVisibility(false);
      
      if(
        this.isAuthenticationPopupAvailable && 
        isPasswordPopupClosedByBackButton
      ) {
        this.setAuthenticationPopupVisibility(true);
      }
    },
    activatePassword(password) {
      this.password = password;
      this.submitChanges();
    }
  },
};
</script>
